import { Component } from '@angular/core';
import { ApiMethod } from '../apimethods/api-method';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../common/global-constants';
declare var $;


@Component({
  selector: 'app-counter-component',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.css']
})

export class CounterComponent {
  journalList: any;
  tableList: any;
  aFieldList = [];
  constructor() {
    this.getJournalsList();

  }
  ngAfterViewChecked(): void {
    $('.tblDataList').css('height', (GlobalConstants.size.height - 200));
  }

  getJournalsList() {
    $("#LoadingImage").show();
    ApiMethod.getMethod("api/GetJournalsList/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;
        $('#ddlJournal,#ddlTableName').select2({ placeholder: "Select", dropdownParent: "#divBody" });
        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getFieldList(): void {
    $("#LoadingImage").show();
    ApiMethod.getMethod("gen/FieldConfigList/" + $('#ddlTableName').val()
      + "/" + $('#ddlJournal').val()
      + "/" + localStorage.aPubID).subscribe(
        result => {
          this.aFieldList = result.fieldList;
          this.tableList = result.tableList
          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });
  }
  Reset(): void {
    location.reload();
  }

  addNewRow(): void {
    let trcount = $('#tblDataList tbody tr').length + 1;
    var nRowL = "<tr>";
    nRowL += '<td>' + trcount + '</td>';
    nRowL += '<td><input type="text" /></td>';
    nRowL += '<td><input type="text" /></td>';
    nRowL += '<td><input type="text" /></td>';
    nRowL += '<td><input type="checkbox" name="IsVisible"/></td>';
    nRowL += '<td><input type="checkbox" name="IsEditable"/></td>';
    nRowL += '<td><input type="checkbox" name="IsMandatory"/></td>';
    nRowL += '<td><input type="checkbox" name="IsConfirmation"/></td>';
    nRowL += '<td><input type="number" style="width: 70px" /></td>';
    nRowL += '<td><input type="text" style="width: 100px" /></td>';
    nRowL += '<td><input type="number" style="width: 70px" /></td>';
    nRowL += "</tr>";
    $('#tblDataList tbody').append(nRowL);
  }

  updateFieldDetails(): void {
    $("#LoadingImage").show();
    var getFieldList = GlobalConstants.GetTableRowToList('tblDataList', null);
    console.log(getFieldList);
    var dataItem = {
      PublisherId: localStorage.aPubID,
      JournalId: $('#ddlJournal').val(),
      FieldList: JSON.stringify(getFieldList)
    };
    ApiMethod.postMethod("gen/updateField", dataItem).subscribe(
      resonse => {
        $("#LoadingImage").hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Updated !",
          text: resonse,
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImage").hide();
      }
    );

  }
}



